import { render, staticRenderFns } from "./OnAccount.vue?vue&type=template&id=34dc55d0&"
import script from "./OnAccount.vue?vue&type=script&lang=js&"
export * from "./OnAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports